import styled from 'styled-components';

export const StyledAgentCreated = styled.div`
  width: 100%;

  .holder {
    max-width: 400px;
    margin: 0 auto;
    padding: 10px 0 30px;
    text-align: center;

    @media (min-width: 768px) {
      font-size: 18px;
      line-height: 22px;
    }
  }

  .icon {
    display: block;
    font-size: 50px;
    line-height: 1;
    color: #1a2a6c;
    margin: 0 auto 15px;
  }
`;
